export class MFATrustDeviceModel
{
    TrustDevice!: Boolean;
    Device!: string;
    
}